var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        "background-color": "#3b425d",
        "min-height": "100vh",
        padding: "10px",
      },
    },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "content",
                    staticStyle: {
                      "max-width": "480px",
                      margin: "0 auto",
                      color: "#FFF",
                      "padding-top": "30px",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        display: "block",
                        margin: "0 auto",
                        "max-width": "100%",
                        "margin-bottom": "30px",
                      },
                      attrs: {
                        src: require("@/assets/img/question.png"),
                        alt: "",
                      },
                    }),
                    _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "ResumeGuid",
                        value: "@ViewBag.ResumeGuid",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "font-size": "2em",
                        },
                      },
                      [_vm._v(" 是否願意報到？ ")]
                    ),
                    _c("div", { staticClass: "switch-wrap" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.OnBoard,
                              expression: "OnBoard",
                            },
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.OnBoard, true),
                          },
                          on: {
                            change: function ($event) {
                              _vm.OnBoard = true
                            },
                          },
                        }),
                        _c("span", [_vm._v("是")]),
                      ]),
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.OnBoard,
                              expression: "OnBoard",
                            },
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: false,
                            checked: _vm._q(_vm.OnBoard, false),
                          },
                          on: {
                            change: function ($event) {
                              _vm.OnBoard = false
                            },
                          },
                        }),
                        _c("span", [_vm._v("否")]),
                      ]),
                    ]),
                    !_vm.OnBoard
                      ? _c(
                          "div",
                          { staticClass: "decline-block" },
                          [
                            _c("div", { staticClass: "note" }, [
                              _vm._v(
                                " 感謝您參與本公司面談，請協助填入放棄報到原因，以利本公司記錄，望未來還有合作的機會。 "
                              ),
                            ]),
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.Reason,
                                              expression: "Reason",
                                            },
                                          ],
                                          attrs: {
                                            rows: "5",
                                            placeholder: "請輸入婉拒原因",
                                          },
                                          domProps: { value: _vm.Reason },
                                          on: {
                                            compositionstart: function (
                                              $event
                                            ) {
                                              _vm.is_composing = true
                                            },
                                            compositionend: function ($event) {
                                              _vm.is_composing = false
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.Reason = $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        errors && !_vm.is_composing
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("br"),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          staticStyle: { "margin-right": "15px" },
                          attrs: { type: "button" },
                          on: { click: _vm.goBack },
                        },
                        [_vm._v(" 返回 ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return handleSubmit(_vm.replyMessages)
                            },
                          },
                        },
                        [_vm._v(" 送出 ")]
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }